import * as React from 'react';
import {useEffect, useState} from 'react';
import TextField from '@mui/material/TextField';
import {FormGenContentItem, FormGenLayoutSource} from "./FormGenContainer";
import {StyledBoxRow} from "./StyledComponents";
import {CountrySelect, CountrySelectValueType} from "./components/CountrySelect";
import {COUNTRIES} from "./countries";

export function FormGenPhoneNumber(props: {
  contentItem: FormGenContentItem,
  index: number,
  source: FormGenLayoutSource,
  allowedCountryCodes?: string[],
}) {
  const defaultCountryCode = (props.allowedCountryCodes?.length > 0 ? COUNTRIES.find(country => country.code === props.allowedCountryCodes[0]) : null)?.phone || "1";
  let value: string = (props.source.getValue(props.contentItem) as string)?.trim();
  let initialCountryCode: number;
  let initialNationalNumber: number;
  if (value) {
    if (value.startsWith("+")) {
      value = value.substring(1);
    }
    const n = value.indexOf("-");
    if (n < 1) {
      initialCountryCode = 1;
    } else {
      initialCountryCode = Number.parseInt(value.substring(0, n)) || 1;
    }
    initialNationalNumber = Number.parseInt(value.substring(n + 1));
  }
  const [countryPhone, setCountryPhone] = useState<string>(initialCountryCode?.toString() || defaultCountryCode);
  const [nationalNumber, setNationalNumber] = useState<string>(initialNationalNumber?.toString());
  useEffect(() => {
    props.source.setValue(props.contentItem, `+${countryPhone}-${nationalNumber}`);
  }, [countryPhone, nationalNumber]);
  return <StyledBoxRow>
    <CountrySelect
      allowedCountryCodes={props.allowedCountryCodes}
      valueType={CountrySelectValueType.PHONE}
      appearance={{
        showPhone: true,
      }}
      value={countryPhone}
      setValue={value => setCountryPhone(value || defaultCountryCode)}/>
    <TextField
      style={{flexGrow: 1}}
      inputMode={"tel"}
      size="small"
      value={nationalNumber}
      onChange={event => setNationalNumber(event.target.value)}/>
  </StyledBoxRow>;
}
